var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['island-soil']},[(_vm.header)?_c('h4',{staticClass:"island-soil__header"},[_vm._v("\n    "+_vm._s(_vm.header)+"\n  ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }